module.exports = __webpack_public_path__ + "img/ilya-kuvshinov-untitled.df2166c.jpg";